import { jsxs as wM, jsx as x } from "react/jsx-runtime";
import * as uM from "react";
import NM, { useRef as Q, useState as C, useMemo as EM, useEffect as L, useCallback as oM } from "react";
import QM from "react-dom";
var vM = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function UM(M) {
  if (M.__esModule)
    return M;
  var e = M.default;
  if (typeof e == "function") {
    var T = function t() {
      return this instanceof t ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    T.prototype = e.prototype;
  } else
    T = {};
  return Object.defineProperty(T, "__esModule", { value: !0 }), Object.keys(M).forEach(function(t) {
    var D = Object.getOwnPropertyDescriptor(M, t);
    Object.defineProperty(T, t, D.get ? D : {
      enumerable: !0,
      get: function() {
        return M[t];
      }
    });
  }), T;
}
var lM = { exports: {} };
function RM(M, e, T, t) {
  function D(A) {
    return A instanceof T ? A : new T(function(i) {
      i(A);
    });
  }
  return new (T || (T = Promise))(function(A, i) {
    function g(n) {
      try {
        u(t.next(n));
      } catch (I) {
        i(I);
      }
    }
    function w(n) {
      try {
        u(t.throw(n));
      } catch (I) {
        i(I);
      }
    }
    function u(n) {
      n.done ? A(n.value) : D(n.value).then(g, w);
    }
    u((t = t.apply(M, e || [])).next());
  });
}
function _M(M) {
  return M && M.__esModule && Object.prototype.hasOwnProperty.call(M, "default") ? M.default : M;
}
var GM = function M(e, T) {
  if (e === T)
    return !0;
  if (e && T && typeof e == "object" && typeof T == "object") {
    if (e.constructor !== T.constructor)
      return !1;
    var t, D, A;
    if (Array.isArray(e)) {
      if (t = e.length, t != T.length)
        return !1;
      for (D = t; D-- !== 0; )
        if (!M(e[D], T[D]))
          return !1;
      return !0;
    }
    if (e.constructor === RegExp)
      return e.source === T.source && e.flags === T.flags;
    if (e.valueOf !== Object.prototype.valueOf)
      return e.valueOf() === T.valueOf();
    if (e.toString !== Object.prototype.toString)
      return e.toString() === T.toString();
    if (A = Object.keys(e), t = A.length, t !== Object.keys(T).length)
      return !1;
    for (D = t; D-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(T, A[D]))
        return !1;
    for (D = t; D-- !== 0; ) {
      var i = A[D];
      if (!M(e[i], T[i]))
        return !1;
    }
    return !0;
  }
  return e !== e && T !== T;
}, ZM = /* @__PURE__ */ _M(GM);
const IM = "__googleMapsScriptId";
var _;
(function(M) {
  M[M.INITIALIZED = 0] = "INITIALIZED", M[M.LOADING = 1] = "LOADING", M[M.SUCCESS = 2] = "SUCCESS", M[M.FAILURE = 3] = "FAILURE";
})(_ || (_ = {}));
class R {
  /**
   * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
   * using this library, instead the defaults are set by the Google Maps
   * JavaScript API server.
   *
   * ```
   * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
   * ```
   */
  constructor({ apiKey: e, authReferrerPolicy: T, channel: t, client: D, id: A = IM, language: i, libraries: g = [], mapIds: w, nonce: u, region: n, retries: I = 3, url: c = "https://maps.googleapis.com/maps/api/js", version: a }) {
    if (this.callbacks = [], this.done = !1, this.loading = !1, this.errors = [], this.apiKey = e, this.authReferrerPolicy = T, this.channel = t, this.client = D, this.id = A || IM, this.language = i, this.libraries = g, this.mapIds = w, this.nonce = u, this.region = n, this.retries = I, this.url = c, this.version = a, R.instance) {
      if (!ZM(this.options, R.instance.options))
        throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(R.instance.options)}`);
      return R.instance;
    }
    R.instance = this;
  }
  get options() {
    return {
      version: this.version,
      apiKey: this.apiKey,
      channel: this.channel,
      client: this.client,
      id: this.id,
      libraries: this.libraries,
      language: this.language,
      region: this.region,
      mapIds: this.mapIds,
      nonce: this.nonce,
      url: this.url,
      authReferrerPolicy: this.authReferrerPolicy
    };
  }
  get status() {
    return this.errors.length ? _.FAILURE : this.done ? _.SUCCESS : this.loading ? _.LOADING : _.INITIALIZED;
  }
  get failed() {
    return this.done && !this.loading && this.errors.length >= this.retries + 1;
  }
  /**
   * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
   *
   * @ignore
   * @deprecated
   */
  createUrl() {
    let e = this.url;
    return e += "?callback=__googleMapsCallback&loading=async", this.apiKey && (e += `&key=${this.apiKey}`), this.channel && (e += `&channel=${this.channel}`), this.client && (e += `&client=${this.client}`), this.libraries.length > 0 && (e += `&libraries=${this.libraries.join(",")}`), this.language && (e += `&language=${this.language}`), this.region && (e += `&region=${this.region}`), this.version && (e += `&v=${this.version}`), this.mapIds && (e += `&map_ids=${this.mapIds.join(",")}`), this.authReferrerPolicy && (e += `&auth_referrer_policy=${this.authReferrerPolicy}`), e;
  }
  deleteScript() {
    const e = document.getElementById(this.id);
    e && e.remove();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   * @deprecated, use importLibrary() instead.
   */
  load() {
    return this.loadPromise();
  }
  /**
   * Load the Google Maps JavaScript API script and return a Promise.
   *
   * @ignore
   * @deprecated, use importLibrary() instead.
   */
  loadPromise() {
    return new Promise((e, T) => {
      this.loadCallback((t) => {
        t ? T(t.error) : e(window.google);
      });
    });
  }
  importLibrary(e) {
    return this.execute(), google.maps.importLibrary(e);
  }
  /**
   * Load the Google Maps JavaScript API script with a callback.
   * @deprecated, use importLibrary() instead.
   */
  loadCallback(e) {
    this.callbacks.push(e), this.execute();
  }
  /**
   * Set the script on document.
   */
  setScript() {
    var e, T;
    if (document.getElementById(this.id)) {
      this.callback();
      return;
    }
    const t = {
      key: this.apiKey,
      channel: this.channel,
      client: this.client,
      libraries: this.libraries.length && this.libraries,
      v: this.version,
      mapIds: this.mapIds,
      language: this.language,
      region: this.region,
      authReferrerPolicy: this.authReferrerPolicy
    };
    Object.keys(t).forEach(
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (A) => !t[A] && delete t[A]
    ), !((T = (e = window?.google) === null || e === void 0 ? void 0 : e.maps) === null || T === void 0) && T.importLibrary || ((A) => {
      let i, g, w, u = "The Google Maps JavaScript API", n = "google", I = "importLibrary", c = "__ib__", a = document, s = window;
      s = s[n] || (s[n] = {});
      const d = s.maps || (s.maps = {}), z = /* @__PURE__ */ new Set(), O = new URLSearchParams(), V = () => (
        // @ts-ignore
        i || (i = new Promise((h, y) => RM(this, void 0, void 0, function* () {
          var m;
          yield g = a.createElement("script"), g.id = this.id, O.set("libraries", [...z] + "");
          for (w in A)
            O.set(w.replace(/[A-Z]/g, (p) => "_" + p[0].toLowerCase()), A[w]);
          O.set("callback", n + ".maps." + c), g.src = this.url + "?" + O, d[c] = h, g.onerror = () => i = y(Error(u + " could not load.")), g.nonce = this.nonce || ((m = a.querySelector("script[nonce]")) === null || m === void 0 ? void 0 : m.nonce) || "", a.head.append(g);
        })))
      );
      d[I] ? console.warn(u + " only loads once. Ignoring:", A) : d[I] = (h, ...y) => z.add(h) && V().then(() => d[I](h, ...y));
    })(t);
    const D = this.libraries.map((A) => this.importLibrary(A));
    D.length || D.push(this.importLibrary("core")), Promise.all(D).then(() => this.callback(), (A) => {
      const i = new ErrorEvent("error", { error: A });
      this.loadErrorCallback(i);
    });
  }
  /**
   * Reset the loader state.
   */
  reset() {
    this.deleteScript(), this.done = !1, this.loading = !1, this.errors = [], this.onerrorEvent = null;
  }
  resetIfRetryingFailed() {
    this.failed && this.reset();
  }
  loadErrorCallback(e) {
    if (this.errors.push(e), this.errors.length <= this.retries) {
      const T = this.errors.length * Math.pow(2, this.errors.length);
      console.error(`Failed to load Google Maps script, retrying in ${T} ms.`), setTimeout(() => {
        this.deleteScript(), this.setScript();
      }, T);
    } else
      this.onerrorEvent = e, this.callback();
  }
  callback() {
    this.done = !0, this.loading = !1, this.callbacks.forEach((e) => {
      e(this.onerrorEvent);
    }), this.callbacks = [];
  }
  execute() {
    if (this.resetIfRetryingFailed(), !this.loading)
      if (this.done)
        this.callback();
      else {
        if (window.google && window.google.maps && window.google.maps.version) {
          console.warn("Google Maps already loaded outside @googlemaps/js-api-loader. This may result in undesirable behavior as options and script parameters may not match."), this.callback();
          return;
        }
        this.loading = !0, this.setScript();
      }
  }
}
const HM = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  DEFAULT_ID: IM,
  Loader: R,
  get LoaderStatus() {
    return _;
  }
}, Symbol.toStringTag, { value: "Module" })), BM = /* @__PURE__ */ UM(HM);
(function(M, e) {
  (function(T, t) {
    t(e, BM, NM);
  })(vM, function(T, t, D) {
    function A(w) {
      return w && typeof w == "object" && "default" in w ? w : { default: w };
    }
    var i = /* @__PURE__ */ A(D);
    T.Status = void 0, function(w) {
      w.LOADING = "LOADING", w.FAILURE = "FAILURE", w.SUCCESS = "SUCCESS";
    }(T.Status || (T.Status = {}));
    const g = ({ children: w, render: u, callback: n, ...I }) => {
      const [c, a] = D.useState(T.Status.LOADING);
      return D.useEffect(() => {
        const s = new t.Loader(I), d = (z) => {
          n && n(z, s), a(z);
        };
        d(T.Status.LOADING), s.load().then(() => d(T.Status.SUCCESS), () => d(T.Status.FAILURE));
      }, []), c === T.Status.SUCCESS && w ? i.default.createElement(i.default.Fragment, null, w) : u ? u(c) : i.default.createElement(i.default.Fragment, null);
    };
    T.Wrapper = g, Object.defineProperty(T, "__esModule", { value: !0 });
  });
})(lM, lM.exports);
var JM = lM.exports;
function zM(M) {
  var e, T, t = "";
  if (typeof M == "string" || typeof M == "number")
    t += M;
  else if (typeof M == "object")
    if (Array.isArray(M))
      for (e = 0; e < M.length; e++)
        M[e] && (T = zM(M[e])) && (t && (t += " "), t += T);
    else
      for (e in M)
        M[e] && (t && (t += " "), t += e);
  return t;
}
function VM() {
  for (var M, e, T = 0, t = ""; T < arguments.length; )
    (M = arguments[T++]) && (e = zM(M)) && (t && (t += " "), t += e);
  return t;
}
const WM = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgc3R5bGU9ImZpbGw6IHJnYigzNiwgNjUsIDEyMSk7dHJhbnNmb3JtOiA7bXNGaWx0ZXI6OyI+PHBhdGggZD0iTTE5IDJINUMzLjM0NiAyIDIgMy4zNDYgMiA1djIuODMxYzAgMS4wNTMuMzgyIDIuMDEgMSAyLjc0NlYyMGExIDEgMCAwIDAgMSAxaDhhMSAxIDAgMCAwIDEtMXYtNWg0djVhMSAxIDAgMCAwIDEgMWgyYTEgMSAwIDAgMCAxLTF2LTkuNDI0Yy42MTgtLjczNSAxLTEuNjkyIDEtMi43NDZWNWMwLTEuNjU0LTEuMzQ2LTMtMy0zem0xIDN2Mi44MzFjMCAxLjE0LS44NDkgMi4xMTItMS44OTEgMi4xNjdMMTggMTBjLTEuMTAzIDAtMi0uODk3LTItMlY0aDNjLjU1MiAwIDEgLjQ0OSAxIDF6TTEwIDhWNGg0djRjMCAxLjEwMy0uODk3IDItMiAycy0yLS44OTctMi0yek00IDVjMC0uNTUxLjQ0OC0xIDEtMWgzdjRjMCAxLjEwMy0uODk3IDItMiAybC0uMTA5LS4wMDNDNC44NDkgOS45NDMgNCA4Ljk3MSA0IDcuODMxVjV6bTYgMTFINnYtM2g0djN6Ij48L3BhdGg+PC9zdmc+", PM = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgc3R5bGU9ImZpbGw6IHJnYigzNiwgNjUsIDEyMSk7dHJhbnNmb3JtOiA7bXNGaWx0ZXI6OyI+PHBhdGggZD0iTTE5IDJINWEyIDIgMCAwIDAtMiAydjEzYTIgMiAwIDAgMCAyIDJoNGwzIDMgMy0zaDRhMiAyIDAgMCAwIDItMlY0YTIgMiAwIDAgMC0yLTJ6bS03IDNjMS43MjcgMCAzIDEuMjcyIDMgM3MtMS4yNzMgMy0zIDNjLTEuNzI2IDAtMy0xLjI3Mi0zLTNzMS4yNzQtMyAzLTN6TTcuMTc3IDE2Yy41NTgtMS43MjMgMi40OTYtMyA0LjgyMy0zczQuMjY2IDEuMjc3IDQuODIzIDNINy4xNzd6Ij48L3BhdGg+PC9zdmc+", yM = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAxNy4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4KCjxzdmcKICAgdmVyc2lvbj0iMS4xIgogICBpZD0iQ2FwYV8xIgogICB4PSIwcHgiCiAgIHk9IjBweCIKICAgdmlld0JveD0iMCAwIDMyLjM1NTQ2MyA0NC4yOTA4OTIiCiAgIHhtbDpzcGFjZT0icHJlc2VydmUiCiAgIHdpZHRoPSIzMi4zNTU0NjEiCiAgIGhlaWdodD0iNDQuMjkwODkiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGRlZnMKICAgaWQ9ImRlZnMxNyIgLz4mIzEwOzxnCiAgIGlkPSJnMiIKICAgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTE1NC42ODM5NSwtMTA1LjQ2ODgpIj4mIzEwOwk8cGF0aAogICBkPSJtIDE3MC44NjE0MiwxMDUuNDY4OCBjIC04LjkyMDM3LDAgLTE2LjE3NzQ3LDcuMjU3MjYgLTE2LjE3NzQ3LDE2LjE3Nzk3IDAsNS4zODg4MyA0Ljk1Njc4LDEzLjg5MzkzIDcuMDg3NzcsMTcuMzAwNDkgMS43NTMxNiwyLjgwMjQyIDMuNjM1MjEsNS40NjY2NyA1LjI5OTIxLDcuNTAyMTkgMi43MDYwMywzLjMxMDI0IDMuNDY1OTksMy4zMTAyNCAzLjc5MDYsMy4zMTAyNCAwLjMxMTU3LDAgMS4wNDEwMiwwIDMuNzM3NzMsLTMuMzExMTYgMS42NjgyMSwtMi4wNDg1MSAzLjU1MTgyLC00LjcxMjM0IDUuMzAzNzksLTcuNTAwMjkgMi4xNDU1MywtMy40MTQ2OSA3LjEzNjM2LC0xMS45MzY0NSA3LjEzNjM2LC0xNy4zMDE0NyAwLC04LjkyMDcxIC03LjI1NzIzLC0xNi4xNzc5NyAtMTYuMTc3OTksLTE2LjE3Nzk3IHogbSAxLjFlLTQsMjkuMjQ2MTQgYyAtNy4wNTcwNCwwIC0xMi43OTg0OSwtNS43NDE1MiAtMTIuNzk4NDksLTEyLjc5ODYgMCwtNy4wNTcwNyA1Ljc0MTQ1LC0xMi43OTg1MyAxMi43OTg0OSwtMTIuNzk4NTMgNy4wNTcxNiwwIDEyLjc5ODU5LDUuNzQxNDYgMTIuNzk4NTksMTIuNzk4NTMgMCw3LjA1NzA4IC01Ljc0MTQzLDEyLjc5ODYgLTEyLjc5ODU5LDEyLjc5ODYgeiIKICAgaWQ9InBhdGgxIgogICBzdHlsZT0iZmlsbDojMjQ0MTc5O2ZpbGwtb3BhY2l0eToxO3N0cm9rZS13aWR0aDowLjE3MDQ4OSIgLz4mIzEwOwkmIzEwOzxwYXRoCiAgIHN0eWxlPSJmaWxsOiMyNDQxNzk7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlLXdpZHRoOjAuMDU3MDAzIgogICBkPSJtIDE2MS45NDk2NCwxMjguNzMwNjMgYyAtMC4yODM1OCwtMC4xMDQzMSAtMC40ODI0NSwtMC4yOTA1OCAtMC42MTM2MiwtMC41NzQ4OCAtMC4wOTc5LC0wLjIxMTk0IC0wLjEwNTMyLC0wLjQyODY1IC0wLjEwNjE2LC0zLjA3ODA5IC0wLjAwMiwtMi4yMTE0MyAwLjAxNzcsLTIuOTcxNTEgMC4wODIxLC0zLjM5MTY4IDAuMSwtMC42NTMwMiAwLjI2MTY0LC0xLjI3Njg1IDAuNDUwNDgsLTEuNzM4NTcgMC4wNzY5LC0wLjE4ODA5IDAuMTMwNTEsLTAuMzUxNSAwLjExOTA2LC0wLjM2MzExIC0wLjAxMTMsLTAuMDExNiAtMC4xNDEzOSwtMC4wNDM2IC0wLjI4ODc0LC0wLjA3MTIgLTAuNjA2NzUsLTAuMTEzNCAtMC44NzQxNiwtMC41MjA0MiAtMC44NzYxNSwtMS4zMzM2NiAtMC4wMDMsLTAuNjQ3OTkgMC4wOTIzLC0wLjg1Mzg5IDAuNDc2OTYsLTEuMDQ3NDEgbCAwLjI3MDg4LC0wLjEzNjIzIDAuNjY0NzUsMC4xNzcxMyBjIDAuMzY1NjIsMC4wOTc1IDAuNjgxMjksMC4xNTg3NCAwLjcwMTQ5LDAuMTM2MjQgMC4wMjAyLC0wLjAyMjQgMC4yNjA3MiwtMC41OTI0MSAwLjUzNDUxLC0xLjI2NjQ3IDAuMjczODIsLTAuNjc0MDMgMC41NjQ2OSwtMS4zNTAwOCAwLjY0NjQxLC0xLjUwMjI5IDAuMTkxNzEsLTAuMzU3MTggMC41NzAyOSwtMC42OTExOCAxLjAzNTk2LC0wLjkxNDAyIGwgMC4zNzA1MiwtMC4xNzcyOSA1LjMyNTQ0LC0wLjAxNTMgYyA1Ljk1MDYxLC0wLjAxNzIgNS42MjcyNiwtMC4wMzcyIDYuMjY0NSwwLjM4ODI3IDAuMTkwNiwwLjEyNzI4IDAuNDM1ODYsMC4zNTMwNSAwLjU0NDk4LDAuNTAxNjggMC4xMTMyMywwLjE1NDE2IDAuNDMzNTcsMC44NDQ0MSAwLjc0NTgxLDEuNjA2NjggMC4zMDExMywwLjczNTAxIDAuNTY2MjEsMS4zNTUxMyAwLjU4OTE2LDEuMzc4MDQgMC4wMjMsMC4wMjMxIDAuMzQwODQsLTAuMDM4IDAuNzA2NDMsLTAuMTM1NDYgbCAwLjY2NDc5LC0wLjE3NzE0IDAuMjcwODUsMC4xMzYyNCBjIDAuMzg0NzIsMC4xOTM1MSAwLjQ3ODUzLDAuMzk5NDMgMC40NzY4OSwxLjA0NzM4IC0wLjAwNCwwLjgxMzMgLTAuMjY5MzUsMS4yMjAzMyAtMC44NzYxMSwxLjMzMzY4IC0wLjE0NzMyLDAuMDI3NSAtMC4yNzk0OSwwLjA2MTggLTAuMjkzNzEsMC4wNzU4IC0wLjAxNDUsMC4wMTQyIDAuMDM3NSwwLjE4MTM5IDAuMTE0OCwwLjM3MTYgMC4xODc3MywwLjQ2MTk0IDAuMzUzMDcsMS4xMTcwOSAwLjQ1NzE3LDEuODEwOTUgMC4xMDcwOSwwLjcxNDUzIDAuMTI1NzksNS44OTcwNyAwLjAyMjMsNi4yNjg5OCAtMC4wODA2LDAuMjkwNTEgLTAuNDE2NywwLjYyNjU3IC0wLjcwNzI3LDAuNzA3MjUgLTAuMjg2MzEsMC4wNzk1IC0xLjY5NTY2LDAuMDgyNSAtMS45Nzc3MiwwLjAwNSAtMC4yODM1NywtMC4wNzg4IC0wLjU1MDc2LC0wLjMxMjU4IC0wLjY3ODQ0LC0wLjU5Mzc1IC0wLjA4NDQsLTAuMTg1NzYgLTAuMTA0ODYsLTAuMzc2NDEgLTAuMTA1ODQsLTAuOTg1NjIgbCAtMC4wMDUsLTAuNzU1MjMgaCAtNi4wOTE1MiAtNi4wOTM5MiBsIC0wLjAxOTcsMC44MTIyNSBjIC0wLjAxNzgsMC43MzY4MyAtMC4wMzIxLDAuODMyNTIgLTAuMTU0ODgsMS4wMjk5IC0wLjA3NDQsMC4xMTk2OSAtMC4yMzkxOCwwLjI4NjQ0IC0wLjM2NjE3LDAuMzcwNTUgLTAuMjIzNTgsMC4xNDgwNSAtMC4yNTk5LDAuMTUzMzYgLTEuMTQ3MjgsMC4xNjcxMyAtMC42NzgxLDAuMDEwNSAtMC45NzMzOCwtMC4wMDggLTEuMTM1NTUsLTAuMDY2NCB6IG0gNS4xMjQsLTQuNDQ4NDYgYyAwLjEzNjksLTAuMTM2OTUgMC4xMzk5MiwtMC4xNTkyNiAwLjEzOTkyLC0xLjA1NzExIDAsLTAuODk3ODQgLTAuMDA1LC0wLjkyMDE4IC0wLjEzOTkyLC0xLjA1NzEyIGwgLTAuMTM5OTYsLTAuMTM5OTEgaCAtMS43MTUyNiAtMS43MTUyMyBsIC0wLjEzOTk0LDAuMTM5OTEgYyAtMC4xMzY5NSwwLjEzNjk0IC0wLjEzOTg3LDAuMTU5MjggLTAuMTM5ODcsMS4wNTcxMiAwLDAuODk3ODUgMC4wMDQsMC45MjAxNiAwLjEzOTg3LDEuMDU3MTEgbCAwLjEzOTk0LDAuMTM5OTQgaCAxLjcxNTIzIDEuNzE1MjYgeiBtIDExLjIxOTIsMC4wMjE4IDAuMTUwMTcsLTAuMTE4MTcgdiAtMC45Mzg5NyBjIDAsLTAuOTIwOTcgLTAuMDA1LC0wLjk0MTY5IC0wLjEzOTkxLC0xLjA3ODg4IGwgLTAuMTM5OTMsLTAuMTM5OTUgLTEuNjk4NCwwLjAwMyBjIC0xLjI0NTIxLDAuMDAzIC0xLjcyMjU0LDAuMDIwNCAtMS43ODg4NiwwLjA3MTIgLTAuMTg5MjgsMC4xNDUzMyAtMC4yMjMwOCwwLjMxNTU1IC0wLjIyMzA4LDEuMTI0IDAsMC44MDg0NiAwLjAzMzksMC45Nzg2NyAwLjIyMzA4LDEuMTIzOTkgMC4wNjY0LDAuMDUwOCAwLjU0MTUsMC4wNjk5IDEuNzc4NTUsMC4wNzEyIDEuNjIzMDEsMC4wMDQgMS42OTM5NiwtMC4wMDUgMS44MzgzOCwtMC4xMTYzMiB6IG0gLTAuMjQ0NDksLTQuNjY1NjcgYyAwLjExNDM0LC0wLjExNDQxIDAuMTY2NiwtMC4yMjM1MSAwLjE2NjYsLTAuMzQ4MTUgMCwtMC4yMjc4NSAtMS42NTIzMywtNC4yNzI0OCAtMS44NTI3MywtNC41MzUyNyAtMC4wODA0LC0wLjEwNTM5IC0wLjI2NzEsLTAuMjYyNzMgLTAuNDE1MDEsLTAuMzQ5NjUgbCAtMC4yNjg4MywtMC4xNTggaCAtNC44MTY3MiBjIC00LjU5MDM1LDAgLTQuODI2MDQsMC4wMDUgLTUuMDE2MiwwLjEwNjI3IC0wLjI3ODA1LDAuMTQ4MSAtMC41MDQzMSwwLjM2OTQ5IC0wLjYzMjc1LDAuNjE5MjYgLTAuMDYsMC4xMTY4NSAtMC40NjgyLDEuMDg4MTMgLTAuOTA2ODIsMi4xNTgzOSAtMC45MTI5MywyLjIyNzQ3IC0wLjk0MzQsMi4zNzQyIC0wLjU0MTAxLDIuNjA0OTcgMC4wODM5LDAuMDQ4MSAxLjk1NjY3LDAuMDY1OCA3LjExNTQxLDAuMDY3MSBsIDcuMDAxNDgsMC4wMDQgeiIKICAgaWQ9InBhdGgxNyIgLz48L2c+JiMxMDsmIzEwOyYjMTA7JiMxMDsmIzEwOyYjMTA7JiMxMDsmIzEwOyYjMTA7JiMxMDsmIzEwOyYjMTA7JiMxMDsmIzEwOyYjMTA7JiMxMDs8L3N2Zz4K", FM = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIiA/Pg0KPCFET0NUWVBFIHN2ZyBQVUJMSUMgIi0vL1czQy8vRFREIFNWRyAxLjEvL0VOIiAiaHR0cDovL3d3dy53My5vcmcvR3JhcGhpY3MvU1ZHLzEuMS9EVEQvc3ZnMTEuZHRkIj4NCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiANCiAgIHdpZHRoPSI1MCINCiAgIGhlaWdodD0iNTAiIHZpZXdCb3g9IjAgMCAxMDgwIDEwODAiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPGRlc2M+Q3JlYXRlZCB3aXRoIEZhYnJpYy5qcyA1LjIuNDwvZGVzYz4NCjxkZWZzPg0KPC9kZWZzPg0KPGcgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgMSA1NDAgNTQwKSIgaWQ9ImNiYjlmZTY0LTZlMTEtNGM5Yy1iNzRhLTUxMTQ0NDAyNGMxMiIgID4NCjwvZz4NCjxnIHRyYW5zZm9ybT0ibWF0cml4KDEgMCAwIDEgNTQwIDU0MCkiIGlkPSJhZTEyMDEyMS1mNWJkLTRlZDktYTkxOC1lNjRjNDVlZDNjMTUiICA+DQo8cmVjdCBzdHlsZT0ic3Ryb2tlOiBub25lOyBzdHJva2Utd2lkdGg6IDE7IHN0cm9rZS1kYXNoYXJyYXk6IG5vbmU7IHN0cm9rZS1saW5lY2FwOiBidXR0OyBzdHJva2UtZGFzaG9mZnNldDogMDsgc3Ryb2tlLWxpbmVqb2luOiBtaXRlcjsgc3Ryb2tlLW1pdGVybGltaXQ6IDQ7IGZpbGw6IHJnYigyNTUsMjU1LDI1NSk7IGZpbGwtcnVsZTogbm9uemVybzsgb3BhY2l0eTogMTsgdmlzaWJpbGl0eTogaGlkZGVuOyIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiAgeD0iLTU0MCIgeT0iLTU0MCIgcng9IjAiIHJ5PSIwIiB3aWR0aD0iMTA4MCIgaGVpZ2h0PSIxMDgwIiAvPg0KPC9nPg0KPGcgdHJhbnNmb3JtPSJtYXRyaXgoNDQuMzQgMCAwIDQ0LjM0IDU0MCA0MzkuNzcpIiAgPg0KPHBhdGggc3R5bGU9InN0cm9rZTogbm9uZTsgc3Ryb2tlLXdpZHRoOiAwOyBzdHJva2UtZGFzaGFycmF5OiBub25lOyBzdHJva2UtbGluZWNhcDogYnV0dDsgc3Ryb2tlLWRhc2hvZmZzZXQ6IDA7IHN0cm9rZS1saW5lam9pbjogbWl0ZXI7IHN0cm9rZS1taXRlcmxpbWl0OiA0OyBmaWxsOiByZ2IoMTUxLDE1LDE1KTsgZmlsbC1ydWxlOiBub256ZXJvOyBvcGFjaXR5OiAxOyIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiAgdHJhbnNmb3JtPSIgdHJhbnNsYXRlKC0xNzAuODYsIC0xMjEuMTIpIiBkPSJNIDE2MS45NDk2NCAxMjguNzMwNjMgQyAxNjEuNjY2MDYgMTI4LjYyNjMyIDE2MS40NjcxOSAxMjguNDQwMDQ5OTk5OTk5OTkgMTYxLjMzNjAyIDEyOC4xNTU3NDk5OTk5OTk5OCBDIDE2MS4yMzgxMTk5OTk5OTk5OCAxMjcuOTQzODA5OTk5OTk5OTggMTYxLjIzMDY5OTk5OTk5OTk4IDEyNy43MjcwOTk5OTk5OTk5OCAxNjEuMjI5ODYgMTI1LjA3NzY1OTk5OTk5OTk4IEMgMTYxLjIyNzg2IDEyMi44NjYyMjk5OTk5OTk5NyAxNjEuMjQ3NTYgMTIyLjEwNjE0OTk5OTk5OTk5IDE2MS4zMTE5NiAxMjEuNjg1OTc5OTk5OTk5OTkgQyAxNjEuNDExOTYgMTIxLjAzMjk1OTk5OTk5OTk5IDE2MS41NzM2IDEyMC40MDkxMjk5OTk5OTk5OSAxNjEuNzYyNDQgMTE5Ljk0NzQwOTk5OTk5OTk5IEMgMTYxLjgzOTM0IDExOS43NTkzMTk5OTk5OTk5OSAxNjEuODkyOTQ5OTk5OTk5OTggMTE5LjU5NTkwOTk5OTk5OTk5IDE2MS44ODE1IDExOS41ODQyOTk5OTk5OTk5OCBDIDE2MS44NzAxOTk5OTk5OTk5OCAxMTkuNTcyNjk5OTk5OTk5OTggMTYxLjc0MDExIDExOS41NDA2OTk5OTk5OTk5OSAxNjEuNTkyNzYgMTE5LjUxMzA5OTk5OTk5OTk4IEMgMTYwLjk4NjAxIDExOS4zOTk2OTk5OTk5OTk5OCAxNjAuNzE4NiAxMTguOTkyNjc5OTk5OTk5OTggMTYwLjcxNjYxIDExOC4xNzk0Mzk5OTk5OTk5OSBDIDE2MC43MTM2MTAwMDAwMDAwMiAxMTcuNTMxNDQ5OTk5OTk5OTkgMTYwLjgwODkxIDExNy4zMjU1NDk5OTk5OTk5OCAxNjEuMTkzNTcgMTE3LjEzMjAyOTk5OTk5OTk5IEwgMTYxLjQ2NDQ1IDExNi45OTU3OTk5OTk5OTk5OSBMIDE2Mi4xMjkyIDExNy4xNzI5MyBDIDE2Mi40OTQ4MiAxMTcuMjcwNDI5OTk5OTk5OTkgMTYyLjgxMDQ5IDExNy4zMzE2Njk5OTk5OTk5OSAxNjIuODMwNjkgMTE3LjMwOTE3IEMgMTYyLjg1MDg5IDExNy4yODY3Njk5OTk5OTk5OSAxNjMuMDkxNDEgMTE2LjcxNjc2IDE2My4zNjUyMDAwMDAwMDAwMiAxMTYuMDQyNyBDIDE2My42MzkwMjAwMDAwMDAwMiAxMTUuMzY4NjcgMTYzLjkyOTg5MDAwMDAwMDAzIDExNC42OTI2MTk5OTk5OTk5OSAxNjQuMDExNjEwMDAwMDAwMDIgMTE0LjU0MDQxIEMgMTY0LjIwMzMyMDAwMDAwMDAyIDExNC4xODMyMyAxNjQuNTgxOTAwMDAwMDAwMDIgMTEzLjg0OTIyOTk5OTk5OTk5IDE2NS4wNDc1NyAxMTMuNjI2MzkgTCAxNjUuNDE4MDkgMTEzLjQ0OTEgTCAxNzAuNzQzNTMwMDAwMDAwMDIgMTEzLjQzMzggQyAxNzYuNjk0MTQwMDAwMDAwMDMgMTEzLjQxNjYgMTc2LjM3MDc5MDAwMDAwMDAzIDExMy4zOTY2IDE3Ny4wMDgwMzAwMDAwMDAwMiAxMTMuODIyMDcwMDAwMDAwMDEgQyAxNzcuMTk4NjMgMTEzLjk0OTM1MDAwMDAwMDAxIDE3Ny40NDM4OSAxMTQuMTc1MTIgMTc3LjU1MzAxMDAwMDAwMDAzIDExNC4zMjM3NSBDIDE3Ny42NjYyNDAwMDAwMDAwMiAxMTQuNDc3OTEwMDAwMDAwMDEgMTc3Ljk4NjU4MDAwMDAwMDAzIDExNS4xNjgxNiAxNzguMjk4ODIwMDAwMDAwMDMgMTE1LjkzMDQzIEMgMTc4LjU5OTk1MDAwMDAwMDA0IDExNi42NjU0NCAxNzguODY1MDMwMDAwMDAwMDUgMTE3LjI4NTU2IDE3OC44ODc5ODAwMDAwMDAwMyAxMTcuMzA4NDcgQyAxNzguOTEwOTgwMDAwMDAwMDIgMTE3LjMzMTU3IDE3OS4yMjg4MiAxMTcuMjcwNDcgMTc5LjU5NDQxMDAwMDAwMDA0IDExNy4xNzMwMSBMIDE4MC4yNTkyMDAwMDAwMDAwNSAxMTYuOTk1ODcwMDAwMDAwMDEgTCAxODAuNTMwMDUwMDAwMDAwMDUgMTE3LjEzMjExMDAwMDAwMDAxIEMgMTgwLjkxNDc3MDAwMDAwMDAzIDExNy4zMjU2MjAwMDAwMDAwMSAxODEuMDA4NTgwMDAwMDAwMDUgMTE3LjUzMTU0IDE4MS4wMDY5NDAwMDAwMDAwNCAxMTguMTc5NDkwMDAwMDAwMDIgQyAxODEuMDAyOTQwMDAwMDAwMDUgMTE4Ljk5Mjc5MDAwMDAwMDAxIDE4MC43Mzc1OTAwMDAwMDAwNCAxMTkuMzk5ODIwMDAwMDAwMDIgMTgwLjEzMDgzMDAwMDAwMDAzIDExOS41MTMxNzAwMDAwMDAwMiBDIDE3OS45ODM1MTAwMDAwMDAwMiAxMTkuNTQwNjcwMDAwMDAwMDIgMTc5Ljg1MTM0MDAwMDAwMDAyIDExOS41NzQ5NzAwMDAwMDAwMiAxNzkuODM3MTIwMDAwMDAwMDMgMTE5LjU4ODk3MDAwMDAwMDAyIEMgMTc5LjgyMjYyMDAwMDAwMDAzIDExOS42MDMxNzAwMDAwMDAwMiAxNzkuODc0NjIwMDAwMDAwMDIgMTE5Ljc3MDM2MDAwMDAwMDAxIDE3OS45NTE5MjAwMDAwMDAwMyAxMTkuOTYwNTcwMDAwMDAwMDIgQyAxODAuMTM5NjUwMDAwMDAwMDIgMTIwLjQyMjUxMDAwMDAwMDAyIDE4MC4zMDQ5OTAwMDAwMDAwMyAxMjEuMDc3NjYwMDAwMDAwMDIgMTgwLjQwOTA5MDAwMDAwMDAyIDEyMS43NzE1MjAwMDAwMDAwMiBDIDE4MC41MTYxODAwMDAwMDAwMiAxMjIuNDg2MDUwMDAwMDAwMDIgMTgwLjUzNDg4MDAwMDAwMDAyIDEyNy42Njg1OTAwMDAwMDAwMiAxODAuNDMxMzkwMDAwMDAwMDIgMTI4LjA0MDUwMDAwMDAwMDA0IEMgMTgwLjM1MDc5MDAwMDAwMDAyIDEyOC4zMzEwMTAwMDAwMDAwNSAxODAuMDE0NjkwMDAwMDAwMDMgMTI4LjY2NzA3MDAwMDAwMDAyIDE3OS43MjQxMjAwMDAwMDAwMyAxMjguNzQ3NzUwMDAwMDAwMDIgQyAxNzkuNDM3ODEwMDAwMDAwMDQgMTI4LjgyNzI1MDAwMDAwMDAyIDE3OC4wMjg0NjAwMDAwMDAwMiAxMjguODMwMjUwMDAwMDAwMDQgMTc3Ljc0NjQwMDAwMDAwMDAyIDEyOC43NTI3NTAwMDAwMDAwMiBDIDE3Ny40NjI4MzAwMDAwMDAwMyAxMjguNjczOTUwMDAwMDAwMDIgMTc3LjE5NTY0MDAwMDAwMDAzIDEyOC40NDAxNzAwMDAwMDAwMiAxNzcuMDY3OTYwMDAwMDAwMDMgMTI4LjE1OTAwMDAwMDAwMDAyIEMgMTc2Ljk4MzU2MDAwMDAwMDA0IDEyNy45NzMyNDAwMDAwMDAwMiAxNzYuOTYzMTAwMDAwMDAwMDMgMTI3Ljc4MjU5MDAwMDAwMDAxIDE3Ni45NjIxMjAwMDAwMDAwMyAxMjcuMTczMzgwMDAwMDAwMDIgTCAxNzYuOTU3MTIwMDAwMDAwMDMgMTI2LjQxODE1MDAwMDAwMDAzIEwgMTcwLjg2NTYwMDAwMDAwMDAzIDEyNi40MTgxNTAwMDAwMDAwMyBMIDE2NC43NzE2ODAwMDAwMDAwMyAxMjYuNDE4MTUwMDAwMDAwMDMgTCAxNjQuNzUxOTgwMDAwMDAwMDMgMTI3LjIzMDQwMDAwMDAwMDAzIEMgMTY0LjczNDE4MDAwMDAwMDA0IDEyNy45NjcyMzAwMDAwMDAwMyAxNjQuNzE5ODgwMDAwMDAwMDIgMTI4LjA2MjkyMDAwMDAwMDAyIDE2NC41OTcxMDAwMDAwMDAwNCAxMjguMjYwMzAwMDAwMDAwMDMgQyAxNjQuNTIyNzAwMDAwMDAwMDQgMTI4LjM3OTk5MDAwMDAwMDAyIDE2NC4zNTc5MjAwMDAwMDAwNCAxMjguNTQ2NzQwMDAwMDAwMDMgMTY0LjIzMDkzMDAwMDAwMDAzIDEyOC42MzA4NTAwMDAwMDAwNCBDIDE2NC4wMDczNTAwMDAwMDAwMyAxMjguNzc4OTAwMDAwMDAwMDUgMTYzLjk3MTAzMDAwMDAwMDA0IDEyOC43ODQyMTAwMDAwMDAwMyAxNjMuMDgzNjUwMDAwMDAwMDMgMTI4Ljc5Nzk4MDAwMDAwMDAyIEMgMTYyLjQwNTU1MDAwMDAwMDAzIDEyOC44MDg0ODAwMDAwMDAwMyAxNjIuMTEwMjcwMDAwMDAwMDQgMTI4Ljc4OTk4IDE2MS45NDgxMDAwMDAwMDAwNCAxMjguNzMxNTgwMDAwMDAwMDQgeiBNIDE2Ny4wNzM2Mzk5OTk5OTk5OCAxMjQuMjgyMTcgQyAxNjcuMjEwNTM5OTk5OTk5OTggMTI0LjE0NTIyIDE2Ny4yMTM1NTk5OTk5OTk5NyAxMjQuMTIyOTA5OTk5OTk5OTkgMTY3LjIxMzU1OTk5OTk5OTk3IDEyMy4yMjUwNiBDIDE2Ny4yMTM1NTk5OTk5OTk5NyAxMjIuMzI3MjIgMTY3LjIwODU1OTk5OTk5OTk4IDEyMi4zMDQ4OCAxNjcuMDczNjM5OTk5OTk5OTggMTIyLjE2Nzk0IEwgMTY2LjkzMzY3OTk5OTk5OTk4IDEyMi4wMjgwMyBMIDE2NS4yMTg0MTk5OTk5OTk5OCAxMjIuMDI4MDMgTCAxNjMuNTAzMTkgMTIyLjAyODAzIEwgMTYzLjM2MzI1IDEyMi4xNjc5NCBDIDE2My4yMjYyOTk5OTk5OTk5OCAxMjIuMzA0ODggMTYzLjIyMzM4IDEyMi4zMjcyMiAxNjMuMjIzMzggMTIzLjIyNTA2IEMgMTYzLjIyMzM4IDEyNC4xMjI5MSAxNjMuMjI3Mzc5OTk5OTk5OTggMTI0LjE0NTIyIDE2My4zNjMyNSAxMjQuMjgyMTcgTCAxNjMuNTAzMTkgMTI0LjQyMjEwOTk5OTk5OTk5IEwgMTY1LjIxODQxOTk5OTk5OTk4IDEyNC40MjIxMDk5OTk5OTk5OSBMIDE2Ni45MzM2Nzk5OTk5OTk5OCAxMjQuNDIyMTA5OTk5OTk5OTkgeiBNIDE3OC4yOTI4Mzk5OTk5OTk5OCAxMjQuMzAzOTY5OTk5OTk5OTkgTCAxNzguNDQzMDEgMTI0LjE4NTc5OTk5OTk5OTk5IEwgMTc4LjQ0MzAxIDEyMy4yNDY4Mjk5OTk5OTk5OSBDIDE3OC40NDMwMSAxMjIuMzI1ODU5OTk5OTk5OTkgMTc4LjQzODAxIDEyMi4zMDUxNCAxNzguMzAzMSAxMjIuMTY3OTQ5OTk5OTk5OTkgTCAxNzguMTYzMTcgMTIyLjAyNzk5OTk5OTk5OTk5IEwgMTc2LjQ2NDc3MDAwMDAwMDAyIDEyMi4wMzA5OTk5OTk5OTk5OSBDIDE3NS4yMTk1NjAwMDAwMDAwMyAxMjIuMDMzOTk5OTk5OTk5OTkgMTc0Ljc0MjIzIDEyMi4wNTEzOTk5OTk5OTk5OSAxNzQuNjc1OTEwMDAwMDAwMDIgMTIyLjEwMjIgQyAxNzQuNDg2NjMwMDAwMDAwMDIgMTIyLjI0NzUzIDE3NC40NTI4MyAxMjIuNDE3NzUgMTc0LjQ1MjgzIDEyMy4yMjYxOTk5OTk5OTk5OSBDIDE3NC40NTI4MyAxMjQuMDM0NjU5OTk5OTk5OTkgMTc0LjQ4NjczIDEyNC4yMDQ4Njk5OTk5OTk5OSAxNzQuNjc1OTEwMDAwMDAwMDIgMTI0LjM1MDE5IEMgMTc0Ljc0MjMxIDEyNC40MDA5OSAxNzUuMjE3NDEwMDAwMDAwMDMgMTI0LjQyMDA5IDE3Ni40NTQ0NiAxMjQuNDIxMzkgQyAxNzguMDc3NDcgMTI0LjQyNTM5MDAwMDAwMDAxIDE3OC4xNDg0MjAwMDAwMDAwMiAxMjQuNDE2MzkgMTc4LjI5Mjg0IDEyNC4zMDUwNyB6IE0gMTc4LjA0ODM0OTk5OTk5OTk3IDExOS42MzgyOTk5OTk5OTk5OSBDIDE3OC4xNjI2ODk5OTk5OTk5NyAxMTkuNTIzODg5OTk5OTk5OTggMTc4LjIxNDk0OTk5OTk5OTk2IDExOS40MTQ3ODk5OTk5OTk5OCAxNzguMjE0OTQ5OTk5OTk5OTYgMTE5LjI5MDE0OTk5OTk5OTk4IEMgMTc4LjIxNDk0OTk5OTk5OTk2IDExOS4wNjIyOTk5OTk5OTk5OCAxNzYuNTYyNjE5OTk5OTk5OTUgMTE1LjAxNzY2OTk5OTk5OTk4IDE3Ni4zNjIyMTk5OTk5OTk5NSAxMTQuNzU0ODc5OTk5OTk5OTkgQyAxNzYuMjgxODE5OTk5OTk5OTUgMTE0LjY0OTQ4OTk5OTk5OTk5IDE3Ni4wOTUxMTk5OTk5OTk5NSAxMTQuNDkyMTQ5OTk5OTk5OTggMTc1Ljk0NzIwOTk5OTk5OTk2IDExNC40MDUyMjk5OTk5OTk5OSBMIDE3NS42NzgzNzk5OTk5OTk5NSAxMTQuMjQ3MjI5OTk5OTk5OTkgTCAxNzAuODYxNjU5OTk5OTk5OTQgMTE0LjI0NzIyOTk5OTk5OTk5IEMgMTY2LjI3MTMwOTk5OTk5OTk0IDExNC4yNDcyMjk5OTk5OTk5OSAxNjYuMDM1NjE5OTk5OTk5OTQgMTE0LjI1MjIyOTk5OTk5OTk4IDE2NS44NDU0NTk5OTk5OTk5NSAxMTQuMzUzNDk5OTk5OTk5OTggQyAxNjUuNTY3NDA5OTk5OTk5OTQgMTE0LjUwMTU5OTk5OTk5OTk4IDE2NS4zNDExNDk5OTk5OTk5NCAxMTQuNzIyOTg5OTk5OTk5OTggMTY1LjIxMjcwOTk5OTk5OTk2IDExNC45NzI3NTk5OTk5OTk5OCBDIDE2NS4xNTI3MDk5OTk5OTk5NiAxMTUuMDg5NjA5OTk5OTk5OTggMTY0Ljc0NDUwOTk5OTk5OTk2IDExNi4wNjA4ODk5OTk5OTk5OSAxNjQuMzA1ODg5OTk5OTk5OTUgMTE3LjEzMTE0OTk5OTk5OTk4IEMgMTYzLjM5Mjk1OTk5OTk5OTk2IDExOS4zNTg2MTk5OTk5OTk5NyAxNjMuMzYyNDg5OTk5OTk5OTUgMTE5LjUwNTM0OTk5OTk5OTk4IDE2My43NjQ4Nzk5OTk5OTk5NSAxMTkuNzM2MTE5OTk5OTk5OTcgQyAxNjMuODQ4Nzc5OTk5OTk5OTUgMTE5Ljc4NDIxOTk5OTk5OTk4IDE2NS43MjE1NDk5OTk5OTk5NSAxMTkuODAxOTE5OTk5OTk5OTcgMTcwLjg4MDI4OTk5OTk5OTk1IDExOS44MDMyMTk5OTk5OTk5NyBMIDE3Ny44ODE3Njk5OTk5OTk5MyAxMTkuODA3MjE5OTk5OTk5OTcgeiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiAvPg0KPC9nPg0KPC9zdmc+", sM = "0123456789bcdefghjkmnpqrstuvwxyz";
class k {
  /**
   * Encodes latitude/longitude to geohash, either to specified precision or to automatically
   * evaluated precision.
   *
   * @param   {number} lat - Latitude in degrees.
   * @param   {number} lon - Longitude in degrees.
   * @param   {number} [precision] - Number of characters in resulting geohash.
   * @returns {string} Geohash of supplied latitude/longitude.
   * @throws  Invalid geohash.
   *
   * @example
   *     const geohash = Geohash.encode(52.205, 0.119, 7); // => 'u120fxw'
   */
  static encode(e, T, t) {
    if (typeof t > "u") {
      for (let c = 1; c <= 12; c++) {
        const a = k.encode(e, T, c), s = k.decode(a);
        if (s.lat == e && s.lon == T)
          return a;
      }
      t = 12;
    }
    if (e = Number(e), T = Number(T), t = Number(t), isNaN(e) || isNaN(T) || isNaN(t))
      throw new Error("Invalid geohash");
    let D = 0, A = 0, i = !0, g = "", w = -90, u = 90, n = -180, I = 180;
    for (; g.length < t; ) {
      if (i) {
        const c = (n + I) / 2;
        T >= c ? (D = D * 2 + 1, n = c) : (D = D * 2, I = c);
      } else {
        const c = (w + u) / 2;
        e >= c ? (D = D * 2 + 1, w = c) : (D = D * 2, u = c);
      }
      i = !i, ++A == 5 && (g += sM.charAt(D), A = 0, D = 0);
    }
    return g;
  }
  /**
   * Decode geohash to latitude/longitude (location is approximate centre of geohash cell,
   *     to reasonable precision).
   *
   * @param   {string} geohash - Geohash string to be converted to latitude/longitude.
   * @returns {{lat:number, lon:number}} (Center of) geohashed location.
   * @throws  Invalid geohash.
   *
   * @example
   *     const latlon = Geohash.decode('u120fxw'); // => { lat: 52.205, lon: 0.1188 }
   */
  static decode(e) {
    const T = k.bounds(e), t = T.sw.lat, D = T.sw.lon, A = T.ne.lat, i = T.ne.lon;
    let g = (t + A) / 2, w = (D + i) / 2;
    return g = g.toFixed(Math.floor(2 - Math.log(A - t) / Math.LN10)), w = w.toFixed(Math.floor(2 - Math.log(i - D) / Math.LN10)), { lat: Number(g), lon: Number(w) };
  }
  /**
   * Returns SW/NE latitude/longitude bounds of specified geohash.
   *
   * @param   {string} geohash - Cell that bounds are required of.
   * @returns {{sw: {lat: number, lon: number}, ne: {lat: number, lon: number}}}
   * @throws  Invalid geohash.
   */
  static bounds(e) {
    if (e.length == 0)
      throw new Error("Invalid geohash");
    e = e.toLowerCase();
    let T = !0, t = -90, D = 90, A = -180, i = 180;
    for (let w = 0; w < e.length; w++) {
      const u = e.charAt(w), n = sM.indexOf(u);
      if (n == -1)
        throw new Error("Invalid geohash");
      for (let I = 4; I >= 0; I--) {
        const c = n >> I & 1;
        if (T) {
          const a = (A + i) / 2;
          c == 1 ? A = a : i = a;
        } else {
          const a = (t + D) / 2;
          c == 1 ? t = a : D = a;
        }
        T = !T;
      }
    }
    return {
      sw: { lat: t, lon: A },
      ne: { lat: D, lon: i }
    };
  }
  /**
   * Determines adjacent cell in given direction.
   *
   * @param   geohash - Cell to which adjacent cell is required.
   * @param   direction - Direction from geohash (N/S/E/W).
   * @returns {string} Geocode of adjacent cell.
   * @throws  Invalid geohash.
   */
  static adjacent(e, T) {
    if (e = e.toLowerCase(), T = T.toLowerCase(), e.length == 0)
      throw new Error("Invalid geohash");
    if ("nsew".indexOf(T) == -1)
      throw new Error("Invalid direction");
    const t = {
      n: ["p0r21436x8zb9dcf5h7kjnmqesgutwvy", "bc01fg45238967deuvhjyznpkmstqrwx"],
      s: ["14365h7k9dcfesgujnmqp0r2twvyx8zb", "238967debc01fg45kmstqrwxuvhjyznp"],
      e: ["bc01fg45238967deuvhjyznpkmstqrwx", "p0r21436x8zb9dcf5h7kjnmqesgutwvy"],
      w: ["238967debc01fg45kmstqrwxuvhjyznp", "14365h7k9dcfesgujnmqp0r2twvyx8zb"]
    }, D = {
      n: ["prxz", "bcfguvyz"],
      s: ["028b", "0145hjnp"],
      e: ["bcfguvyz", "prxz"],
      w: ["0145hjnp", "028b"]
    }, A = e.slice(-1);
    let i = e.slice(0, -1);
    const g = e.length % 2;
    return D[T][g].indexOf(A) != -1 && i != "" && (i = k.adjacent(i, T)), i + sM.charAt(t[T][g].indexOf(A));
  }
  /**
   * Returns all 8 adjacent cells to specified geohash.
   *
   * @param   {string} geohash - Geohash neighbours are required of.
   * @returns {{n,ne,e,se,s,sw,w,nw: string}}
   * @throws  Invalid geohash.
   */
  static neighbours(e) {
    return {
      n: k.adjacent(e, "n"),
      ne: k.adjacent(k.adjacent(e, "n"), "e"),
      e: k.adjacent(e, "e"),
      se: k.adjacent(k.adjacent(e, "s"), "e"),
      s: k.adjacent(e, "s"),
      sw: k.adjacent(k.adjacent(e, "s"), "w"),
      w: k.adjacent(e, "w"),
      nw: k.adjacent(k.adjacent(e, "n"), "w")
    };
  }
}
function KM(M) {
  return /* @__PURE__ */ uM.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, M), /* @__PURE__ */ uM.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
  }));
}
var $ = {}, X = QM;
if (process.env.NODE_ENV === "production")
  $.createRoot = X.createRoot, $.hydrateRoot = X.hydrateRoot;
else {
  var rM = X.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  $.createRoot = function(M, e) {
    rM.usingClientEntryPoint = !0;
    try {
      return X.createRoot(M, e);
    } finally {
      rM.usingClientEntryPoint = !1;
    }
  }, $.hydrateRoot = function(M, e, T) {
    rM.usingClientEntryPoint = !0;
    try {
      return X.hydrateRoot(M, e, T);
    } finally {
      rM.usingClientEntryPoint = !1;
    }
  };
}
const XM = ({
  mapState: M,
  setMapState: e,
  className: T,
  onClick: t,
  onDragEnd: D,
  directions: A,
  children: i,
  withResetButton: g,
  resetMapNow: w,
  setResetMapNow: u,
  carCoordinates: n,
  bounds: I,
  setZoom: c,
  setCenter: a,
  setViewableAreaInSquareMeters: s,
  heatmapLayerSettings: d,
  locationsForHeatmap: z,
  currenLocation: O,
  disabledMap: V,
  mapControlsCustomButtons: h,
  ...y
}) => {
  const m = Q(!1), p = Q(
    []
  ), [Y, MM] = C(), G = Q(null), [eM, TM] = C(""), Z = Q(null), tM = () => {
    eM && O?.enabled && O?.enabledSearch && window.google && window.google.maps && new window.google.maps.Geocoder().geocode({ address: eM }, (r, j) => {
      if (j === "OK" && r) {
        const { lat: f, lng: H } = r[0].geometry.location, B = { lat: f(), lng: H() };
        a(B), O?.onLoadLocation && O.onLoadLocation(f(), H(), "searchQuery");
      } else
        console.error(
          "Geocode was not successful for the following reason: " + j
        );
    });
  }, v = Q(y), DM = EM(
    () => JSON.stringify(v.current) !== JSON.stringify(y),
    [y]
  );
  function gM() {
    const N = M?.getBounds(), r = N?.getNorthEast(), j = N?.getSouthWest();
    if (r && j) {
      const f = Math.abs(r.lat() - j.lat()), H = Math.abs(r.lng() - j.lng()), B = f * H, iM = 111e3, AM = B * iM * iM;
      s(AM);
    }
  }
  DM && (v.current = y), M?.addListener("zoom_changed", function() {
    const r = M.getZoom();
    r && c(r);
  }), M?.addListener(
    "center_changed",
    LM(function() {
      if (M) {
        const r = M.getCenter();
        if (r) {
          const j = {
            lat: r.lat(),
            lng: r.lng()
          };
          a(j);
        }
      }
    }, 1e3)
  ), M?.addListener(
    "bounds_changed",
    LM(function() {
      gM();
    }, 1e3)
  ), L(() => {
    O && O?.enabled && O?.onLoadLocation && navigator.geolocation.getCurrentPosition((N) => {
      O?.onLoadLocation && (O?.onLoadLocation(
        N.coords.latitude,
        N.coords.longitude
      ), M?.setOptions(v.current));
    });
  }, [O?.enabled]), L(() => {
    if (G.current && !M) {
      const N = new window.google.maps.Map(G.current, {
        center: y.center,
        zoom: y.zoom,
        scrollwheel: !1,
        gestureHandling: "greedy"
      });
      e(N);
    }
  }, [G, M, y.zoom, y.center]), L(() => {
    M && M.setOptions(v.current);
  }, [M, DM, v.current]), L(() => {
    M && (["click", "idle", "dragend"].forEach((N) => {
      google.maps.event.clearListeners(M, N);
    }), t && M.addListener("click", t), D && M.addListener("dragend", () => {
      D(M.getCenter()?.toJSON());
    }));
  }, [M, t, D]), L(() => {
    if (A?.from && A?.to && M) {
      const N = new google.maps.DirectionsService(), r = new google.maps.DirectionsRenderer({
        suppressMarkers: !0,
        preserveViewport: !0
      });
      r.setMap(M ?? null), N.route(
        {
          origin: A?.from,
          destination: A?.to,
          travelMode: google.maps.TravelMode.DRIVING
        },
        function(j, f) {
          f == "OK" && r.setDirections(j);
        }
      );
    }
  }, [
    // Keep `lat` & `lng` in the deps array. Ignore the warning.
    // Adding `directions?.from` and `directions?.to` will cause the useEffect to run on every re-render
    // because `from` and `to` are objects.
    A?.from.lat,
    A?.from.lng,
    A?.to.lat,
    A?.to.lng,
    M
  ]), L(
    function() {
      w && (e(void 0), u(!1));
    },
    [w, u]
  ), L(() => {
    if (!I)
      return;
    const N = new google.maps.LatLngBounds();
    I.forEach((r) => {
      N.extend(r);
    }), M?.fitBounds(N);
  }, [I, M]), L(
    function() {
      if (d?.show === !1)
        Y?.setMap(null);
      else {
        const r = !aM(
          z,
          p.current
        );
        (Y?.getMap() === void 0 || Y?.getMap() === null) && dM({
          latestMapState: M,
          heatmapRadius: d?.radius,
          showHeatmapLayer: d?.show,
          locationsForHeatmap: z,
          setHeatmapObject: MM
        }), r && (Y?.setMap(null), dM({
          latestMapState: M,
          heatmapRadius: d?.radius,
          showHeatmapLayer: d?.show,
          locationsForHeatmap: z,
          setHeatmapObject: MM
        }));
      }
      p.current = z ? [...z] : [];
    },
    [
      d?.radius,
      d?.show,
      Y,
      z,
      M
    ]
  );
  const nM = () => {
    navigator.geolocation && O && O.onLoadLocation ? navigator.geolocation.getCurrentPosition(
      (N) => {
        const { latitude: r, longitude: j } = N.coords;
        a({ lat: r, lng: j }), O.onLoadLocation && O.onLoadLocation(
          r,
          j,
          "current location"
        );
      },
      (N) => {
        console.error("Error obtaining current location:", N);
      }
    ) : console.error("Geolocation is not supported by this browser.");
  };
  return L(() => {
    if (M && O?.enabled && !V) {
      const N = document.createElement("div"), r = document.createElement("button");
      r.style.backgroundColor = "#fff", r.style.border = "2px solid #fff", r.style.borderRadius = "3px", r.style.boxShadow = "0 2px 6px rgba(0,0,0,.3)", r.style.cursor = "pointer", r.style.marginTop = "10px", r.style.marginRight = "10px", r.style.marginBottom = "10px", r.style.width = "40px", r.style.height = "38px", r.style.textAlign = "center", r.title = "current location", r.innerHTML = '<svg fill="#000000" width="100%" height="30px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><circle cx="12" cy="12" r="4"/><path d="M13 4.069V2h-2v2.069A8.01 8.01 0 0 0 4.069 11H2v2h2.069A8.008 8.008 0 0 0 11 19.931V22h2v-2.069A8.007 8.007 0 0 0 19.931 13H22v-2h-2.069A8.008 8.008 0 0 0 13 4.069zM12 18c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z"/></svg>', N.appendChild(r), r.addEventListener("click", nM), M.controls[window.google.maps.ControlPosition.RIGHT_BOTTOM].push(
        r
      );
    }
  }, [M]), L(
    function() {
      if (M && h && h.length > 0 && m.current === !1) {
        for (let r = 0; r < h.length; r++) {
          const j = h[r];
          if (j.hidden === void 0 || j.hidden === !1) {
            const f = document.createElement("div");
            document.body.appendChild(f), $.createRoot(f).render(j.button), M.controls[j.position].push(f);
          }
        }
        m.current = !0;
      }
    },
    [h, M]
  ), L(() => {
    if (!(!window.google || !M || !O?.enabledSearch) && Z.current) {
      const N = new window.google.maps.places.Autocomplete(
        Z.current
      );
      N.setFields(["geometry", "formatted_address"]), N.addListener("place_changed", () => {
        const r = N.getPlace();
        if (r.geometry) {
          console.log(r, "place"), TM(r?.formatted_address?.toString() ?? "");
          const j = {
            lat: r?.geometry?.location?.lat() ?? 0,
            lng: r?.geometry?.location?.lng() ?? 0
          };
          a(j), O?.onLoadLocation && O.onLoadLocation(
            r?.geometry?.location?.lat() ?? 0,
            r?.geometry?.location?.lng() ?? 0,
            "searchQuery"
          );
        }
      });
    }
  }, [M, Z]), /* @__PURE__ */ wM("div", { className: "relative w-full h-full", children: [
    /* @__PURE__ */ x("div", { className: T, ref: G }),
    /* @__PURE__ */ wM("div", { className: "flex flex-col gap-2 items-center justify-center", children: [
      NM.Children.map(i, (N) => {
        if (NM.isValidElement(N))
          return NM.cloneElement(N, { ...N.props, map: M });
      }),
      O?.enabledSearch && /* @__PURE__ */ x("div", { className: "absolute top-12 left-0 m-auto right-0  md:w-1/3 w-11/12 z-10 p-2 rounded-md", children: /* @__PURE__ */ wM("div", { className: "flex w-full bg-white border border-gray-300 rounded-md shadow-sm  focus-within:ring-primary-400 focus-within:border-primary-400", children: [
        /* @__PURE__ */ x("div", { className: "p-2 w-full relative", children: /* @__PURE__ */ x(
          "input",
          {
            ref: Z,
            type: "text",
            placeholder: O.searchPlaceholder ?? "",
            className: "autocomplete-input appearance-none placeholder-gray-400 sm:text-sm w-full focus:outline-none",
            onChange: (N) => {
              TM(N.target.value);
            },
            onKeyDown: (N) => {
              N.key === "Enter" && tM();
            }
          }
        ) }),
        /* @__PURE__ */ x("div", { className: "select-none flex items-center px-2 bg-secondary-50 text-black ltr:rounded-r-md rtl:rounded-l-md relative", children: /* @__PURE__ */ x(
          KM,
          {
            className: "bg-white h-full w-6 absolute right-0 pe-2 rounded-e-md",
            onClick: tM
          }
        ) })
      ] }) }),
      g && /* @__PURE__ */ x(
        "button",
        {
          type: "button",
          className: "p-1 ml-4 rounded border-2 border-gray-200",
          onClick: function() {
            u(!0);
          },
          children: "Reset"
        }
      )
    ] })
  ] });
}, LM = (M, e) => {
  let T;
  return function(...t) {
    const D = this;
    clearTimeout(T), T = setTimeout(() => {
      M.apply(D, t);
    }, e);
  };
}, aM = (M, e) => {
  const T = JSON.stringify(M), t = JSON.stringify(e);
  return T === t;
};
function dM({
  showHeatmapLayer: M = !1,
  heatmapRadius: e = 50,
  latestMapState: T,
  locationsForHeatmap: t,
  setHeatmapObject: D
}) {
  if (window.google.maps.visualization && // Check if the visualization library is added
  M && T)
    if (t === void 0)
      console.error(
        "Unable to initiate the heatmap. multipleMarkers prop is missing."
      );
    else {
      const A = t.map(
        function(w) {
          return new window.google.maps.LatLng(
            w.lat,
            w.lng
          );
        }
      ), i = new window.google.maps.visualization.HeatmapLayer({
        data: A,
        radius: e
        // map: latestMapState,
      });
      i.setMap(T), D(i);
    }
}
var qM = /* @__PURE__ */ ((M) => (M[M.TOP_LEFT = 1] = "TOP_LEFT", M[M.TOP = 2] = "TOP", M[M.TOP_CENTER = 2] = "TOP_CENTER", M[M.TOP_RIGHT = 3] = "TOP_RIGHT", M[M.LEFT_CENTER = 4] = "LEFT_CENTER", M[M.LEFT = 5] = "LEFT", M[M.LEFT_TOP = 5] = "LEFT_TOP", M[M.LEFT_BOTTOM = 6] = "LEFT_BOTTOM", M[M.RIGHT = 7] = "RIGHT", M[M.RIGHT_TOP = 7] = "RIGHT_TOP", M[M.RIGHT_CENTER = 8] = "RIGHT_CENTER", M[M.RIGHT_BOTTOM = 9] = "RIGHT_BOTTOM", M[M.BOTTOM_LEFT = 10] = "BOTTOM_LEFT", M[M.BOTTOM = 11] = "BOTTOM", M[M.BOTTOM_CENTER = 11] = "BOTTOM_CENTER", M[M.BOTTOM_RIGHT = 12] = "BOTTOM_RIGHT", M[M.CENTER = 13] = "CENTER", M[M.BLOCK_START_INLINE_START = 14] = "BLOCK_START_INLINE_START", M[M.BLOCK_START_INLINE_CENTER = 15] = "BLOCK_START_INLINE_CENTER", M[M.BLOCK_START_INLINE_END = 16] = "BLOCK_START_INLINE_END", M[M.INLINE_START_BLOCK_CENTER = 17] = "INLINE_START_BLOCK_CENTER", M[M.INLINE_START_BLOCK_START = 18] = "INLINE_START_BLOCK_START", M[M.INLINE_START_BLOCK_END = 19] = "INLINE_START_BLOCK_END", M[M.INLINE_END_BLOCK_START = 20] = "INLINE_END_BLOCK_START", M[M.INLINE_END_BLOCK_CENTER = 21] = "INLINE_END_BLOCK_CENTER", M[M.INLINE_END_BLOCK_END = 22] = "INLINE_END_BLOCK_END", M[M.BLOCK_END_INLINE_START = 23] = "BLOCK_END_INLINE_START", M[M.BLOCK_END_INLINE_CENTER = 24] = "BLOCK_END_INLINE_CENTER", M[M.BLOCK_END_INLINE_END = 25] = "BLOCK_END_INLINE_END", M))(qM || {});
const q = (M) => {
  const [e, T] = C();
  return L(() => (e || T(
    () => new google.maps.Marker({ title: M.title })
  ), () => {
    e && e.setMap(null);
  }), [e, M.title]), L(() => {
    if (e) {
      const { onClickCallbackHandler: t } = M;
      e.setOptions(M), t && e.addListener("click", function() {
        t();
      });
    }
  }, [e, M]), null;
}, kM = {
  strokeColor: "#F8A61A",
  strokeOpacity: 0.8,
  strokeWeight: 3,
  fillColor: "rgb(248, 166, 26)",
  fillOpacity: 0.32,
  draggable: !0,
  editable: !0
}, $M = ({
  map: M,
  onPolygonPathChange: e,
  defaultPolygonPath: T
}) => {
  const t = Q(T), D = Q(), A = oM((i) => {
    const g = i.getPath();
    e(
      g.getArray().map((w) => ({
        lat: w.lat(),
        lng: w.lng()
      }))
    );
  }, [e]);
  L(() => {
    if (M) {
      if (t.current) {
        const i = new google.maps.Polygon({
          ...kM,
          paths: t.current
        });
        return i.setMap(M), google.maps.event.addListener(
          i.getPath(),
          "set_at",
          function() {
            A(i);
          }
        ), google.maps.event.addListener(
          i.getPath(),
          "remove_at",
          function() {
            A(i);
          }
        ), google.maps.event.addListener(
          i.getPath(),
          "insert_at",
          function() {
            A(i);
          }
        ), i.addListener("dragend", function() {
          A(i);
        }), () => {
          i.setMap(null);
        };
      }
      return t.current || (D.current = new google.maps.drawing.DrawingManager({
        drawingMode: google.maps.drawing.OverlayType.POLYGON,
        drawingControl: !0,
        drawingControlOptions: {
          position: google.maps.ControlPosition.TOP_CENTER,
          drawingModes: [google.maps.drawing.OverlayType.POLYGON]
        },
        polygonOptions: kM
      }), D.current.setMap(M), google.maps.event.addListener(
        D.current,
        "polygoncomplete",
        function(i) {
          A(i), google.maps.event.addListener(
            i.getPath(),
            "set_at",
            function() {
              A(i);
            }
          ), google.maps.event.addListener(
            i.getPath(),
            "remove_at",
            function() {
              A(i);
            }
          ), google.maps.event.addListener(
            i.getPath(),
            "insert_at",
            function() {
              A(i);
            }
          ), i.addListener("dragend", function() {
            A(i);
          }), D.current?.setMap(null);
        }
      )), () => {
        D.current?.setMap(null);
      };
    }
  }, [M, A]);
}, Me = (M) => ($M(M), null), ee = (M) => /* @__PURE__ */ x("h1", { children: M }), Ae = ({
  lat: M,
  lng: e,
  onCoordsChange: T,
  onDragEnd: t,
  defaults: D,
  mapContainerStyles: A,
  showPin: i = !0,
  directions: g,
  carCoordinates: w,
  googleApiKey: u = {}.VITE_GOOGLE_MAPS_API_KEY,
  disabled: n = !1,
  directionsReady: I = !0,
  polygonDrawingProps: c,
  withResetButton: a = !1,
  multipleMarkersData: s,
  bounds: d,
  heatMapSettings: z,
  geohashAccuracyFactor: O = 0,
  currenLocation: V,
  mapControlsCustomButtons: h
}) => {
  const [y, m] = C(), [p, Y] = C(!1), { zoom: MM = 5, minZoom: G, maxZoom: eM } = D, [TM, Z] = C(""), [tM, v] = C(""), [DM, gM] = C(""), [nM, N] = C(""), [r, j] = C(""), [f, H] = C(""), [B, iM] = C(MM), [AM, xM] = C(""), [U, J] = C({
    lat: 0,
    lng: 0
  }), [cM, CM] = C(), jM = Q();
  function fM() {
    Y(!0);
  }
  const hM = oM(
    (o, l) => {
      !g && !l && o.latLng && (T?.(o.latLng.lat(), o.latLng.lng()), J(
        () => o.latLng ? { ...o.latLng.toJSON() } : { lat: 0, lng: 0 }
      ));
    },
    [g, T]
  );
  function SM({
    viewableAreaInSquareMetersArg: o,
    accuracyFactor: l = 0
  }) {
    let E;
    if (o)
      for (let S = 0; S <= 11; S++) {
        const K = Te[S];
        if (o <= K) {
          S === 0 ? E = 12 : E = 12 - S - l;
          break;
        }
      }
    return E;
  }
  const W = {
    lat: M,
    lng: e,
    isVisible: !g && i
  }, P = {
    coords: w,
    icon: yM,
    isVisible: !!w
  }, bM = AM.length, F = z?.enabled ? bM >= z.disableAtGeohashPrecisionDegree : !0, mM = EM(
    function() {
      return !W.isVisible && F && s && s.markers.length > 0 && s.markers.map(function(E, S) {
        const K = aM(
          s.selectedMarkerCoords,
          E.coords
        ), OM = E.selected || K;
        return E.coords ? /* @__PURE__ */ x(
          q,
          {
            position: {
              lat: E.coords.lat,
              lng: E.coords.lng
            },
            icon: E.icon ? E.icon : OM ? FM : yM,
            onClickCallbackHandler: E.onClickCallbackHandler,
            mapState: y,
            title: E.markerTitle
          },
          S
        ) : null;
      });
    },
    [
      y,
      s,
      F,
      W.isVisible
    ]
  ), pM = oM(
    (o) => {
      o && (t?.(o.lat, o.lng), J(o), T?.(o.lat, o.lng));
    },
    [t, T]
  ), YM = I ? /* @__PURE__ */ x("div", { className: VM("flex h-96", A), children: /* @__PURE__ */ x(
    JM.Wrapper,
    {
      apiKey: u,
      render: ee,
      libraries: ["places", "geometry", "drawing", "visualization"],
      children: /* @__PURE__ */ wM(
        XM,
        {
          mapState: y,
          setMapState: m,
          center: U,
          setCenter: J,
          currenLocation: V,
          zoom: B,
          minZoom: G,
          maxZoom: eM,
          setZoom: iM,
          disableDefaultUI: n,
          disabledMap: n,
          disableDoubleClickZoom: n,
          draggable: !n,
          onClick: (o) => hM(o, n),
          className: "grow h-full w-full",
          directions: g,
          carCoordinates: w,
          withResetButton: a,
          heatmapLayerSettings: {
            show: !F,
            radius: z?.radius
          },
          locationsForHeatmap: s?.markers?.map(
            function(l) {
              return {
                lat: l.coords?.lat,
                lng: l.coords?.lng
              };
            }
          ),
          bounds: d,
          resetMapNow: p,
          setResetMapNow: Y,
          setViewableAreaInSquareMeters: CM,
          onDragEnd: (o) => pM(o ?? { lat: M, lng: e }),
          mapControlsCustomButtons: h,
          children: [
            W && W.isVisible && /* @__PURE__ */ x(
              q,
              {
                position: {
                  lat: U.lat,
                  // Use the dynamic center state
                  lng: U.lng
                },
                visible: W.isVisible,
                mapState: y
              }
            ),
            P && P.isVisible && /* @__PURE__ */ x(
              q,
              {
                position: P.coords,
                icon: P.icon,
                visible: P.isVisible,
                mapState: y
              }
            ),
            mM,
            /* @__PURE__ */ x(
              q,
              {
                position: g?.from,
                icon: WM,
                visible: !!g,
                mapState: y
              }
            ),
            /* @__PURE__ */ x(
              q,
              {
                position: g?.to,
                icon: PM,
                visible: !!g,
                mapState: y
              }
            ),
            c && // @ts-expect-error - map will be passed by the parent component (Map)
            /* @__PURE__ */ x(Me, { ...c })
          ]
        }
      )
    }
  ) }) : null;
  return L(() => {
    window.google && M && e && window.google.maps.Geocoder && new window.google.maps.Geocoder().geocode({
      language: "en",
      location: {
        lat: M,
        lng: e
      }
    }).then((l) => {
      console.log("Google maps response", l), j(
        l.results.find((b) => b.types.includes("country"))?.formatted_address ?? ""
      );
      const E = l.results.find(
        (b) => b.types.includes("locality")
      ), S = l.results.find(
        (b) => b.types.includes("route")
      )?.address_components[0].short_name, K = l.results.find(
        (b) => b.types.includes("postal_code")
      )?.address_components[0].short_name, OM = l.results.find(
        (b) => b.types.includes("sublocality_level_1")
      )?.address_components[0].long_name;
      Z(S ?? ""), v(K ?? ""), gM(OM ?? ""), N(E?.address_components[0].long_name ?? ""), H(l.results[0].formatted_address ?? "");
    }).catch((l) => {
      console.error(l, "Failed to get Marker's address in Google Maps");
    });
  }, [M, e]), L(
    function() {
      J({
        lat: M,
        lng: e
      });
    },
    [M, e]
  ), L(
    function() {
      if (p && D.lat && D.lng) {
        const l = {
          lat: D.lat,
          lng: D.lng
        };
        J(l);
      }
    },
    [D.lat, D.lng, p]
  ), L(
    function() {
      if (cM) {
        const l = SM({
          viewableAreaInSquareMetersArg: cM,
          accuracyFactor: O
        });
        if (l !== void 0) {
          const E = k.encode(
            U.lat,
            U.lng,
            l
          );
          console.info(l, "geohash precision"), xM(E);
        } else
          console.info("precision beyond 12");
      }
    },
    [cM, U]
  ), L(
    function() {
      const l = !aM(
        jM.current,
        s?.selectedMarkerCoords
      );
      s && s.selectedMarkerCoords && l && // To only re-adjust the center if the markers are shown and not the heatmap.
      F && J({ ...s.selectedMarkerCoords }), jM.current = s?.selectedMarkerCoords;
    },
    [s, F]
  ), {
    googleMapComponent: YM,
    currentMarkerAddress: f,
    currentCountry: r,
    currentCity: nM,
    currentRoute: TM,
    currentDistrict: DM,
    currentPostalCode: tM,
    latestZoomValue: B,
    latestCenterValue: U,
    latestGeohashValue: AM,
    resetMapDrawingAndCenterPoint: fM
  };
}, Te = [
  // W x H
  // 12: <= 37.2mm X 18.6mm (0.00069272 square meters)
  69272e-8,
  // 11: <= 149mm X 149mm (0.022201 square meters)
  0.022201,
  // 10: <= 1.19m X 0.596m (0.71084 square meters)
  0.71084,
  // 9: <= 4.77m X 4.77m (22.77 square meters)
  22.77,
  // 8: <= 38.2m X 19.1m (730.62 square meters)
  730.62,
  // 7: <= 153m X 153m (23,409 square meters)
  23409,
  // 6: <= 1.22km X 0.61km (744,200 square meters)
  744200,
  // 5: <= 4.89km X 4.89km (23,920,000 square meters)
  2392e4,
  // 4: <= 39.1km X 19.5km (762,450,000 square meters)
  76245e4,
  // 3: <= 156km X 156km (24,336,000,000 square meters)
  24336e6,
  // 2: <= 1,250km X 625km (781,250,000,000 square meters)
  78125e7,
  // 1: <= 5000km X 5000km (25,000,000,000,000 square meters)
  25e12
];
export {
  XM as Map,
  qM as MapControlsButtonsPositionEnum,
  aM as objectsDeeplyEqual,
  Ae as useGoogleMaps
};
